import React from 'react'
import img1  from './../../images/sba-report-card.jpg'
export default function ReportHeader() {
  return (
    <div>
    <img src={img1}  width='100%' height='250px' alt='GovT of Punjab'  style={{position:"absolute",top:"0",left:"0",zindex:"-1"}} />
        <div className='p-2'  style={{fontSize:"2.5em", position:"absolute",top:"60px",right:"0",zindex:"1"}}>
          رپورٹ کارڈ برائے تعلیمی سال 2022
      </div>
    </div>
  )
}
